import React from 'react'

import { Outlet } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'

import Footer from '../footer/Footer'
import AppRoot from '../global/AppRoot'
import AppWrap from '../global/AppWrap'

import ThemeProvider from '../../mailTemplate/src/theme/ThemeProvider'

import '../../mailTemplate/src/styles/globals.scss'
import 'flag-icons/css/flag-icons.min.css'
import PaymentHeader from './PaymentHeader'

import PaymentErrorModalHandler from '../../components/paymentErrorModalHandler/PaymentErrorModalHandler'

const PaymentLayout = ({ ...props }) => {
  return (
    <ThemeProvider direction={document.documentElement.dir} systemMode='light'>
      <AppRoot>
        <AppWrap>
          <PaymentHeader fixed/>
          <div
            className="nk-content"
            style={{
              marginTop: '67px',
              height: 'calc(100vh - 67px - 43px)', // vh-header-footer
              overflowY: 'auto'
            }}
          >
            <Outlet/>
          </div>
          <Footer/>
          <PaymentErrorModalHandler/>
        </AppWrap>
      </AppRoot>
      <ToastContainer/>
    </ThemeProvider>
  )
}
export default PaymentLayout
